import { Card, CardHeader, CardTitle, CardContent } from "@components/ui/card";
import BaseLayout from '@components/accounts/AccountBase';
import { PasswordResetRequestForm } from '@/features/reset-password';

const ResetPassword = () => {
  return (
    <BaseLayout>
      <Card className="w-full max-w-md mx-auto">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl text-center">Reset Your Password</CardTitle>
          <p className="text-sm text-gray-600 text-center">
            Enter your email to receive a password reset link
          </p>
        </CardHeader>
        <CardContent>
          <PasswordResetRequestForm />
        </CardContent>
      </Card>
    </BaseLayout>
  );
};

export default ResetPassword; 